"use strict";

var ShineCatalog = require('./catalog');

var ShineImpositions = require('./impositions');

var ShineOrders = require('./orders');

var ShinePricing = require('./pricing');

var ShinePrinting = require('./printing');

var ShineProducts = require('./products');

var ShineShipping = require('./shipping');

var CatalogEntry = require('./catalog/CatalogEntry');

var ImpositionsPath = require('./impositions/ImpositionsPath');

var AlertFactory = require('./factories/AlertFactory');

var OrderFactory = require('./factories/OrderFactory');

var PrintJobFactory = require('./factories/PrintJobFactory');

var ShipmentFactory = require('./factories/ShipmentFactory');

var Address = require('./orders/classes/Address');

var Order = require('./orders/classes/Order');

var OrderNote = require('./orders/classes/OrderNote');

var PriceAdjustment = require('./orders/classes/PriceAdjustment');

var SampleSetsOrder = require('./orders/classes/SampleSetsOrder');

var TestPrintsOrder = require('./orders/classes/TestPrintsOrder');

var Component = require('./products/interfaces/Component');

var Components = require('./products/components');

var ComponentCollection = require('./products/interfaces/ComponentCollection');

var Envelope = require('./products/interfaces/Envelope');

var LetterpressComponent = require('./products/interfaces/LetterpressComponent');

var PaperComponent = require('./products/interfaces/PaperComponent');

var PaperProduct = require('./products/interfaces/PaperProduct');

var Personalization = require('./products/interfaces/Personalization');

var Product = require('./products/interfaces/Product');

var Products = require('./products/products_list');

var InvitationSuite = require('./products/invitation_suites/interface');

var BookletProgram = require('./products/wedding_programs/interface');

var SaveTheDate = require('./products/prewedding_stationery/interface');

var PrintingOption = require('./printing/PrintingOption');

var PrintJob = require('./printing/PrintJob');

var Shipment = require('./shipping/Shipment');

var ShippingOption = require('./shipping/ShippingOption');

var Payment = require('./payments/Payment');

var Invoice = require('./payments/Invoice');

var Alert = require('./alerts/Alert');

module.exports = {
  ShineCatalog: ShineCatalog,
  ShineImpositions: ShineImpositions,
  ShineOrders: ShineOrders,
  ShinePricing: ShinePricing,
  ShinePrinting: ShinePrinting,
  ShineProducts: ShineProducts,
  ShineShipping: ShineShipping,
  CatalogEntry: CatalogEntry,
  ImpositionsPath: ImpositionsPath,
  Address: Address,
  Order: Order,
  OrderNote: OrderNote,
  PriceAdjustment: PriceAdjustment,
  SampleSetsOrder: SampleSetsOrder,
  TestPrintsOrder: TestPrintsOrder,
  Component: Component,
  Components: Components,
  ComponentCollection: ComponentCollection,
  Envelope: Envelope,
  LetterpressComponent: LetterpressComponent,
  PaperComponent: PaperComponent,
  PaperProduct: PaperProduct,
  Personalization: Personalization,
  Product: Product,
  Products: Products,
  InvitationSuite: InvitationSuite,
  BookletProgram: BookletProgram,
  SaveTheDate: SaveTheDate,
  PrintingOption: PrintingOption,
  PrintJob: PrintJob,
  Shipment: Shipment,
  ShippingOption: ShippingOption,
  Payment: Payment,
  Invoice: Invoice,
  Alert: Alert,
  AlertFactory: AlertFactory,
  OrderFactory: OrderFactory,
  PrintJobFactory: PrintJobFactory,
  ShipmentFactory: ShipmentFactory
};